import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { modelService } from "@/lib/services";
import type { DataResponse, ModelTierDefault } from "@/types";

export type ResponseUpdateTierDefault = DataResponse<ModelTierDefault>;

export type UpdateTierDefaultVariables = { tier: string; modelId: string | null };

type UpdateTierDefaultMutationOptions = Omit<
  UseMutationOptions<ResponseUpdateTierDefault, Error, UpdateTierDefaultVariables>,
  "mutationFn"
>;

export const useUpdateTierDefault = (options?: UpdateTierDefaultMutationOptions) => {
  return useMutation<ResponseUpdateTierDefault, Error, UpdateTierDefaultVariables>({
    mutationFn: ({ tier, modelId }) => modelService.updateTierDefault(tier, modelId),
    ...options,
  });
};
